import { defineMessages } from 'react-intl';

const translations = {
  trialDiscount: {
    id: 'pages.contract.sections.upcomingInvoices.row.trialDiscount',
    defaultMessage: 'Trial',
    description: 'label for the trial discount deduction',
  },
};

export default defineMessages(translations);
